import { Fragment, type ReactNode } from 'react'
import {
  ClickableDateCell,
  ClickableTableCell,
  ClickableTableRow,
  ClickableTextCell,
} from '@/components/Table/ClickableTable'
import { Icon } from '@/components/Icon'
import { type ColumnId } from '@/features/jobs/list/jobs-table-columns'
import { type JobsTableStatus } from '@/features/jobs/list/jobs-table-status'
import { StatusCell } from '@/features/jobs/list/components/JobManagement/JobsTable/JobsTableRow'
import { type Id } from '@/infra/id'

export interface FirmDashboardJobsTableRowProps {
  to: string
  columnIds: readonly ColumnId[]
  id: Id
  primaryCell: ReactNode
  shortId: string
  status: JobsTableStatus
  progressionStep: string
  clientTeamName?: string
  dateSubmitted: Date | null
  testId?: string
}

export function FirmDashboardJobsTableRow({
  to,
  columnIds,
  id,
  primaryCell,
  shortId,
  status,
  progressionStep,
  clientTeamName,
  dateSubmitted,
  testId,
}: FirmDashboardJobsTableRowProps) {
  return (
    <ClickableTableRow to={to} data-test={testId}>
      {columnIds.map((columnId) => {
        switch (columnId) {
          case 'jobTitle':
            return <Fragment key={columnId}>{primaryCell}</Fragment>
          case 'jobShortId':
            return (
              <ClickableTextCell testId={`job-short-id-${id}`} key={columnId}>
                {shortId}
              </ClickableTextCell>
            )
          case 'status':
            return (
              <StatusCell
                status={status}
                testId={`job-status-${id}`}
                key={columnId}
              />
            )
          case 'progressionStep':
            return (
              <ClickableTextCell
                testId={`job-progression-step-${id}`}
                key={columnId}
              >
                {progressionStep}
              </ClickableTextCell>
            )
          case 'clientTeam':
            return (
              <ClickableTextCell
                testId={`job-client-team-${id}`}
                key={columnId}
              >
                {clientTeamName}
              </ClickableTextCell>
            )
          case 'submitted':
            return (
              <ClickableDateCell
                date={dateSubmitted}
                density="Comfortable"
                testId={`job-submitted-date-${id}`}
                key={columnId}
              />
            )
          case 'action':
            return (
              <ClickableTableCell key={columnId}>
                <Icon name="arrow" size={24} />
              </ClickableTableCell>
            )
          default:
            return <ClickableTableCell key={columnId} />
        }
      })}
    </ClickableTableRow>
  )
}
